/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { DocumentType } from '../enums/document-type.enum';
import { DocumentClassification } from '../enums/document-classification.enum';
import { FileDto } from './file-dto';

//<custom-head>
import { parseDate, IconUtils, formattedDate } from 'app/utils';
import { environment } from 'environments/environment';
import { EnumUtils } from 'app/enum-utils';
//</custom-head>

export class DocumentDto {
  public id: string = undefined;
  public fileId: string = undefined;
  public type: DocumentType;
  public classification: DocumentClassification;
  public sharedWithCustomer: boolean;
  public file: FileDto;
  public version: number = undefined;
  public fileName: string = undefined;
  public contentType: string = undefined;
  public createdBy: string = undefined;
  public createdUtc: Date | string;
  public modifiedBy: string = undefined;
  public modifiedUtc: Date | string;
  public creator: string = undefined;
  public comment: string = undefined;

  //<custom-body>
  public documentType: DocumentType;

  constructor(source: DocumentDto) {
    Object.assign(this, source);
    this.createdUtc = parseDate(source.createdUtc);
    this.file = source.file ? new FileDto(source.file) : null;
  }

  public static getClassificationFlags(classification: DocumentClassification) {
    return [
      DocumentClassification.ShippingLetter,
      DocumentClassification.Export,
      DocumentClassification.Import,
      DocumentClassification.ProformaInvoice,
      DocumentClassification.Invoice,
      DocumentClassification.GoodsList
    ].filter(c => EnumUtils.hasFlag(classification, c));
  }
  
  public static getClassificationStrings(classification: DocumentClassification) {
    var classificationFlags = DocumentDto.getClassificationFlags(classification);
    return classificationFlags.map(
      cf =>
        'documents.documentClassifications.' +
        DocumentClassification[cf.valueOf()].toLocaleLowerCase()
    );
  }

  public static getClassificationFlagValue(
    classifications: DocumentClassification[]
  ) {
    let documentClassification: DocumentClassification = 0;
    for (let classification of classifications) {
      documentClassification |= classification;
    }
    return documentClassification;
  }

  public get UploadedDate(): string {
    return formattedDate(parseDate(this.createdUtc));
  }

  public get downloadUrl(): string {
    // FIXME: Should be extracted somewhere?
    return `${environment.apiHost}api/files/download/${
      this.file ? this.file.id : this.fileId
    }`;
  }

  public get displayDiff(): string {
    return this.fileName;
  }

  public get iconClass(): string {
    if (!this.file) return IconUtils.contentTypeIconClass(this.contentType);
    return this.file.iconClass;
  }
  //</custom-body>
}
